import React, {FC} from 'react';

//MUI
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

//MUI-ICONS
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';

//BONOS VERDES
import LoginWrapper from './LoginWrapper';
import Link from '@mui/material/Link';
import Avatar from '@mui/material/Avatar';
import {useTranslation} from 'react-i18next';
import Box from '@mui/material/Box';
import {useNavigate} from 'react-router-dom';
import {FormHelperText} from '@mui/material';

const textField = {
  mb: 1,
  height: '64px',
  p: 0,
  '& .MuiInputBase-root': {
    color: '#5F5D70',
    fontWeight: '900',
    backgroundColor: 'grey.100'
  },
  '& .MuiFormHelperText-root': {
    color: 'error.main'
  }
};
const errorText = {
  color: 'error.main',
  mb: 2,
  ml: 2
};
const loginButton = {
  borderRadius: 0,
  height:'48px',
};

export type LoginErrors = {
  [key: string]: Array<string>,
};


export type LoginFormProps = {
  loginErrors?: LoginErrors,
  username: string,
  password: string,
  onUsernameChanged: (name: string) => void,
  onPasswordChanged: (password: string) => void,
  onLoginButtonClicked: () => void,
}

const LoginForm: FC<LoginFormProps> = ({loginErrors, username, password, onUsernameChanged, onPasswordChanged, onLoginButtonClicked}) => {
  const {t, i18n} = useTranslation();
  const navigate = useNavigate();
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => onUsernameChanged(e.target.value);
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => onPasswordChanged(e.target.value);
  const handleLoginClick = (e: React.FormEvent) => {
    e.preventDefault();
    onLoginButtonClicked();
  };

  const handleGoToSignUpClick = () => navigate(`/${i18n.resolvedLanguage}/signup`);

  const handleFieldError = (property: string) => {
    if (loginErrors){
      if (property in loginErrors) {
        return <div>
          {loginErrors[property].map((error, index) => <FormHelperText key={index}>{error}</FormHelperText>)}
        </div>;
      } else {
        return undefined;
      }
    }
  };
  
  return <LoginWrapper>

    <Avatar sx={{m: 1, bgcolor: 'secondary.main'}}>
      <LockIcon/>
    </Avatar>
    <Typography component='h1' variant='h5'>{t('login.signUp')}</Typography>
    <Box component="form" onSubmit={handleLoginClick} noValidate sx={{ mt: 12 }}>
      <TextField
        type='text'
        margin="normal"
        required
        fullWidth
        id="username"
        name="username"
        autoComplete="username"
        autoFocus
        placeholder={t('login.username')}
        sx={textField}
        onChange={handleNameChange}
        value={username}
        helperText={handleFieldError('username')}
        InputProps={{ startAdornment: <AccountCircleIcon sx={{marginRight: 1}} /> }}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        name="password"
        type="password"
        id="password"
        autoComplete="current-password"
        placeholder={t('login.password')}
        sx={textField}
        onChange={handlePasswordChange}
        value={password}
        helperText={handleFieldError('password')}
        InputProps={{ startAdornment: <LockIcon sx={{marginRight: 1}} /> }}
      />
      <Typography variant='body2' sx={errorText}>{handleFieldError('non_field_errors')}</Typography>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2, ...loginButton}}
      >
              ENTRAR
      </Button>
      <Grid container>
        <Grid item>
          <Link onClick={handleGoToSignUpClick} variant="body2">
              No tienes cuenta?
          </Link>
        </Grid>
      </Grid>
    </Box>
    
  </LoginWrapper>;
};

export default LoginForm;